// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../assets/stylesheets/variables.css\"","genericContainer":"_2ELtkcMpIJZ1yyH_kfj3I7","container":"juuQP9KZoU-JsJYtVZz1K _2ELtkcMpIJZ1yyH_kfj3I7"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/conditions/Conditions.css
// module id = 1117
// module chunks = 2